import { Container } from "react-bootstrap";
import '../home.css'
import revenue from "../../../images/home/rev.svg";
import money from "../../../images/home/save.svg";
import customer from "../../../images/home/review.svg";
import performance from "../../../images/home/speed.svg";

const CompanyBenefits = () => {

    return (
        <>
            <section className="company-benefits-section">
                <Container fluid>
                    <div className="text-center mb-4">
                        <h2 className="ft-wt-600 text-uppercase text-white mb-3">Right Technology + Your Business = Exponential Growth</h2>
                        <p className="mb-0 text-white ft-24">If you’re looking to develop a software product to:</p>
                    </div>
                    <div className="contents-wrapper mb-0">
                        <div className="content-item">
                            <img src={revenue} alt="revenue" loading="lazy" />
                            <h5 className="ft-wt-600 text-uppercase text-white">Increase Revenue</h5>
                        </div>
                        <div className="content-item">
                            <img src={money} alt="money" loading="lazy" />
                            <h5 className="ft-wt-600 text-uppercase text-white">Save money by removing unnecessary costs</h5>
                        </div>
                        <div className="content-item">
                            <img src={customer} alt="customer-care" loading="lazy" />
                            <h5 className="ft-wt-600 text-uppercase text-white">Improve your customer’s experience</h5>
                        </div>
                        <div className="content-item">
                            <img src={performance} alt="performance" loading="lazy" />
                            <h5 className="ft-wt-600 text-uppercase text-white">Ultimately transform your business and performance</h5>
                        </div>
                    </div>
                    <p className="mb-0 text-white text-center ft-24">Then it’s crucial to have the right, trusted and reliable software partner for your business.</p>
                </Container>
            </section>
        </>
    )
};

export default CompanyBenefits